// ABOUTME: Configuration for the warehouse relation news management page tab.
// ABOUTME: Single tab listing all relation news messages.

import NewspaperIcon from '@mui/icons-material/Newspaper';

export const warehouseRelationNewsConfig = {
    all: {
        title: 'news',
        icon: <NewspaperIcon />,
    },
};
